import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { callGetNFTCollectionDetails } from '@app/client/resources/yat-pages/page-items';

export type ReservoirTokensDataProps = {
    tokens?: string[];
    customCache?: string;
    interval?: boolean;
};

export const useReservoirTokensData = ({
    tokens = [],
    customCache = '',
    interval = false,
}: ReservoirTokensDataProps = {}) => {
    const { contractParam, idParam } = useParams();

    const formattedContract = contractParam?.startsWith('0x') ? contractParam : `0x${contractParam}`;
    const formattedTokens = new Set(tokens);

    if (formattedContract && idParam) formattedTokens.add(`${formattedContract}:${idParam}`);

    const cache = [customCache || 'collectionData', ...formattedTokens];

    return useQuery({
        queryKey: cache,
        queryFn: ({ signal }) =>
            callGetNFTCollectionDetails({
                query: { includeTopBid: true, includeAttributes: true, tokens: Array.from(formattedTokens).join(',') },
                settings: {
                    signal,
                },
            }),
        refetchInterval: interval && 15000,
        retry: false,
        enabled: !!tokens?.length || Boolean(contractParam && idParam),
    });
};
